import { find, flatten } from "lodash/fp";
import { useNavigate } from "react-router-dom";

import Typography from "@mui/material/Typography";

import CategoryAccordion from "@app/analytics/components/CategoryAccordion";
import useIntegrations from "@app/analytics/hooks/integrations/useIntegrations";
import {
  PROVIDER_CATEGORIES,
  PROVIDER_CONTENT,
} from "@app/analytics/Integrations/constants";
import { Detail } from "@app/analytics/Integrations/styles";
import useResponsiveView from "@app/common/hooks/useResponsiveView";

import IntegrationItem from "./components/IntegrationItem";

const UserIntegrations = () => {
  const navigate = useNavigate();
  const { inDesktopView } = useResponsiveView();
  const { userIntegrationsByCategory } = useIntegrations();

  const allProviders = flatten(Object.values(userIntegrationsByCategory));

  const selectedProviderId = find(
    { route: location.pathname },
    allProviders
  )?.providerId;

  const handleSelectProvider = (route: string) => {
    navigate(route, { replace: inDesktopView });
  };

  return (
    <>
      <Detail>
        Your integrations can only be configured and used by you. For example,
        connecting Gmail will only give you access to your inbox topic
        summaries.
      </Detail>
      {PROVIDER_CATEGORIES.map((category) => {
        const integrations = userIntegrationsByCategory[category.id];
        return (
          <CategoryAccordion
            key={category.id}
            label={category.label}
            borderRadius={0}
            endIcon={
              <Typography variant="bodyPrimaryMed">
                {integrations.length}
              </Typography>
            }
          >
            {integrations.map((integration) => {
              const description =
                PROVIDER_CONTENT[integration.providerId].shortDescription;
              return (
                <IntegrationItem
                  key={integration.providerId}
                  description={description}
                  provider={integration}
                  isSelected={integration.providerId === selectedProviderId}
                  onClick={handleSelectProvider}
                />
              );
            })}
          </CategoryAccordion>
        );
      })}
    </>
  );
};

export default UserIntegrations;
